export const TypeAngles = {
    "Tipo A": 125,
    "Tipo B": 125,
    "Tipo C": 60,
    "Tipo D": 60,
    "Tipo E (Duplex)": 125,
}